export default [
  {
    name: 'Vegetarian (V)',
    tag: 'V',
    value: 'VEGETARIAN'
  },
  {
    name: 'Vegan (VG)',
    tag: 'VG',
    value: 'VEGAN'
  },
  {
    name: 'Gluten Free (GF)',
    tag: 'GF',
    value: 'GLUTEN_FREE'
  },
  {
    name: 'Low Calorie (LC)',
    tag: 'LC',
    value: 'LOW_CALORIE'
  },
  {
    name: 'Low Fat (LF)',
    tag: 'LF',
    value: 'LOW_FAT'
  },
  {
    name: 'Pescetarian',
    tag: 'Pescetarian',
    value: 'PESCETARIAN'
  }
]
